export function parseToExcludeBlanks(value: string | "") {
  return value.replace(/\$\s?|(,*)/g, "");
}
